// ============================================================================
// COOKIE HELPERS
// ============================================================================
function getCookie(name) {
  const cname = `${name}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i].trim();
    if (c.indexOf(cname) === 0) return c.substring(cname.length);
  }
  return '';
}

function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${name}=${encodeURIComponent(value)};${expires};path=/`;
}

// ============================================================================
// PET INFO DROPDOWN TOGGLE HELPER
// ============================================================================
function setupPetInfoDropdown() {
  const summaries = document.querySelectorAll('.pet-info-details .pet-info-toggle');

  summaries.forEach(summary => {
    if (summary.dataset.petToggleBound === '1') return;
    summary.dataset.petToggleBound = '1';

    summary.addEventListener('click', function(e) {
      e.preventDefault();
      const details = this.closest('details');
      if (!details) return;
      details.open = !details.open;
    });
  });
}

// ============================================================================
// UTILITY FUNCTIONS
// ============================================================================
function truncate(str, max = 15) {
  return str.length > max ? `${str.substring(0, max)}...` : str;
}

function formatName(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

// ============================================================================
// MAIN: DISPLAY PET INFO IN CART
// ============================================================================
function displayPetInfoFromCookie() {
  const cartItems = document.querySelectorAll('.cart-item');
  if (!cartItems.length) return;
  
  cartItems.forEach((item) => {
    const petName = item.querySelector('input[name="properties[Pet Name]"]')?.value;
    const petType = item.querySelector('input[name="properties[Pet Type]"]')?.value;
    const petBreed = item.querySelector('input[name="properties[Pet Breed]"]')?.value;
    const petWeight = item.querySelector('input[name="properties[Pet Weight]"]')?.value;
    const petPostcode = item.querySelector('input[name="properties[Pet Postcode]"]')?.value;
    
    if (!petName) return;
    
    let petInfoElement = item.querySelector('.pet-info-display');
    if (!petInfoElement) {
      petInfoElement = document.createElement('div');
      petInfoElement.className = 'pet-info-display';
      const itemDetails = item.querySelector('.cart-item__details');
      if (itemDetails) {
        itemDetails.appendChild(petInfoElement);
      }
    }
    
    petInfoElement.innerHTML = `
      <div class="pet-info-item">
        <span class="pet-info-label">Pet:</span>
        <span class="pet-info-value">${petName || 'N/A'}</span>
      </div>
      <div class="pet-info-item">
        <span class="pet-info-label">Type:</span>
        <span class="pet-info-value">${petType || 'N/A'}</span>
      </div>
      ${petBreed ? `
      <div class="pet-info-item">
        <span class="pet-info-label">Breed:</span>
        <span class="pet-info-value">${petBreed}</span>
      </div>` : ''}
      ${petWeight ? `
      <div class="pet-info-item">
        <span class="pet-info-label">Weight:</span>
        <span class="pet-info-value">${petWeight} kg</span>
      </div>` : ''}
      ${petPostcode ? `
      <div class="pet-info-item">
        <span class="pet-info-label">Postcode:</span>
        <span class="pet-info-value">${petPostcode}</span>
      </div>` : ''}
    `;
  });
  
  const petsInfoCookie = getCookie('pets_info');

  if (petsInfoCookie) {
    try {
      let petsInfo = JSON.parse(petsInfoCookie);

      const petNames = petsInfo.map(pet => pet.name);
      const uniqueNames = [...new Set(petNames)];

      if (petNames.length !== uniqueNames.length) {
        const uniquePets = [];
        const seenNames = new Set();
        petsInfo.forEach(pet => {
          if (!seenNames.has(pet.name)) {
            seenNames.add(pet.name);
            uniquePets.push(pet);
          }
        });

        setCookie('pets_info', JSON.stringify(uniquePets), 30);
        petsInfo = uniquePets;
      }

      window.petsInfo = petsInfo || [];

      const cartItemPetInfoDisplays = document.querySelectorAll('.cart-item-pet-info');

      cartItemPetInfoDisplays.forEach(display => {
        const cartItem = display.closest('.cart-item');
        if (!cartItem) return;

        const petId = display.getAttribute('data-pet-id');
        let matchingPet = null;

        const propertyDebug = cartItem.querySelectorAll('.property-debug');
        let petDetailsProperty = null;
        
        propertyDebug.forEach(debug => {
          const propName = debug.getAttribute('data-property-name');
          if (propName === 'Pet Details') {
            petDetailsProperty = debug.getAttribute('data-property-value');
          }
        });
        
        if (petDetailsProperty) {
          const petInfoLines = petDetailsProperty.split('\n').map(line => line.trim()).filter(line => line);
          const parsedPet = {};
          
          petInfoLines.forEach(line => {
            if (line.startsWith('Type:')) parsedPet.type = line.replace('Type:', '').trim();
            else if (line.startsWith('Name:')) parsedPet.name = line.replace('Name:', '').trim();
            else if (line.startsWith('Breed:')) parsedPet.breed = line.replace('Breed:', '').trim();
            else if (line.startsWith('Weight:')) parsedPet.weight = line.replace('Weight:', '').replace('kg', '').trim();
            else if (line.startsWith('Birthdate:')) parsedPet.birthdate = line.replace('Birthdate:', '').trim();
            else if (line.startsWith('Postcode:')) parsedPet.postcode = line.replace('Postcode:', '').trim();
          });
          
          if (parsedPet.name || parsedPet.type) {
            const pets = window.petsInfo || [];
            const matchedPet = pets.find(pet => 
              pet.name === parsedPet.name && 
              pet.type === parsedPet.type &&
              pet.weight === parsedPet.weight
            );
            
            if (matchedPet) {
              matchingPet = matchedPet;
            } else {
              matchingPet = {
                id: petId || null,
                ...parsedPet
              };
            }
          }
        }
        
        if (!matchingPet && petId) {
          matchingPet = (window.petsInfo || []).find(
            pet => String(pet.id) === String(petId)
          );
        }

        if (!matchingPet) {
          const options = cartItem.querySelectorAll('.product-option');
          let petNameProp = '';
          let petTypeProp = '';
          let petBreedProp = '';
          let petWeightProp = '';
          let petBirthdateProp = '';
          let petPostcodeProp = '';

          options.forEach(opt => {
            const labelEl = opt.querySelector('dt');
            const valueEl = opt.querySelector('dd');
            if (!labelEl || !valueEl) return;

            const label = labelEl.textContent.trim().toLowerCase();
            const value = valueEl.textContent.trim();

            if (label.includes("pet name") || label.includes("pet's name")) {
              petNameProp = value;
            } else if (label.includes("type") && !label.includes("product")) {
              petTypeProp = value;
            } else if (label.includes("breed")) {
              petBreedProp = value;
            } else if (label.includes("weight")) {
              petWeightProp = value;
            } else if (label.includes("birthdate") || label.includes("dob")) {
              petBirthdateProp = value;
            } else if (label.includes("postcode")) {
              petPostcodeProp = value;
            }
          });

          if (petNameProp || petTypeProp || petBreedProp || petWeightProp || petBirthdateProp || petPostcodeProp) {
            matchingPet = {
              id: petId || null,
              name: petNameProp,
              type: petTypeProp,
              breed: petBreedProp,
              weight: petWeightProp,
              birthdate: petBirthdateProp,
              postcode: petPostcodeProp
            };
          }
        }
        
        if (!matchingPet) {
          const pets = window.petsInfo || [];

          if (pets.length === 1) {
            matchingPet = pets[0];
          }
        }

        if (!matchingPet) {
          display.style.display = 'none';
          display.innerHTML = '';
          return;
        }

        const rawPetTitle = formatName(matchingPet.name) || 'Your Pet';
        const petTitle = truncate(rawPetTitle, 15);

        display.innerHTML = `
          <details class="pet-info-details">
            <summary class="pet-info-toggle">
              <span>Pet details for ${petTitle}</span>
              <span class="pet-info-toggle-icon">▾</span>
            </summary>
            <div class="pet-info-content">
              <div class="pet-info-section" data-pet-id="${matchingPet.id || ''}">
                <span class="pet-info-name">${rawPetTitle}</span>
                <div class="pet-info-item">
                  <span class="pet-info-label">Type:</span>
                  <span class="pet-info-value">${matchingPet.type || 'Not specified'}</span>
                </div>
                <div class="pet-info-item">
                  <span class="pet-info-label">Breed:</span>
                  <span class="pet-info-value">${matchingPet.breed || 'Not specified'}</span>
                </div>
                <div class="pet-info-item">
                  <span class="pet-info-label">Weight:</span>
                  <span class="pet-info-value">${matchingPet.weight || 'Not specified'} kg</span>
                </div>
                <div class="pet-info-item">
                  <span class="pet-info-label">Birthdate:</span>
                  <span class="pet-info-value">${matchingPet.birthdate || 'Not specified'}</span>
                </div>
                ${matchingPet.postcode || (matchingPet.address && matchingPet.address.postcode) ? `
                <div class="pet-info-item">
                  <span class="pet-info-label">Postcode:</span>
                  <span class="pet-info-value">${matchingPet.postcode || matchingPet.address.postcode}</span>
                </div>` : ''}
              </div>
            </div>
          </details>
        `;

        display.style.display = 'block';
      });

      setupPetInfoDropdown();
      return;

    } catch (err) {
      // Silent error handling
    }
  }

  try {
    const petInfoCookie = getCookie('pet_info');
    if (petInfoCookie) {
      const petInfo = JSON.parse(petInfoCookie);

      const petTitle = petInfo.name || 'Your Pet';
      const petInfoHTML = `
        <div class="pets-container">
          <div class="pet-info-section">
            <h4 class="pet-info-title">${petTitle}</h4>
            <div class="pet-info-item">
              <span class="pet-info-label">Type:</span>
              <span class="pet-info-value">${petInfo.type || 'Not specified'}</span>
            </div>
            <div class="pet-info-item">
              <span class="pet-info-label">Breed:</span>
              <span class="pet-info-value">${petInfo.breed || 'Not specified'}</span>
            </div>
            <div class="pet-info-item">
              <span class="pet-info-label">Weight:</span>
              <span class="pet-info-value">${petInfo.weight || 'Not specified'} kg</span>
            </div>
            <div class="pet-info-item">
              <span class="pet-info-label">Birthdate:</span>
              <span class="pet-info-value">${petInfo.birthdate || 'Not specified'}</span>
            </div>
            ${petInfo.postcode || (petInfo.address && petInfo.address.postcode) ? `
            <div class="pet-info-item">
              <span class="pet-info-label">Postcode:</span>
              <span class="pet-info-value">${petInfo.postcode || petInfo.address.postcode}</span>
            </div>` : ''}
          </div>
        </div>
      `;

      const cartItemPetInfoDisplays = document.querySelectorAll('.cart-item-pet-info');

      cartItemPetInfoDisplays.forEach(display => {
        display.innerHTML = petInfoHTML;
        display.style.display = 'block';
      });

      setupPetInfoDropdown();
    }
  } catch (fallbackErr) {
    // Silent error handling
  }
}

// ============================================================================
// CART EMPTY / CLEANUP HELPERS
// ============================================================================
function cleanupPetInfoWhenCartEmpty() {
  if (window.clearAllPetInfo) {
    window.clearAllPetInfo();
  } else {
    setCookie('pets_info', '', -1);
    setCookie('pet_info', '', -1);
  }

  const cartItemPetInfoDisplays = document.querySelectorAll('.cart-item-pet-info');
  cartItemPetInfoDisplays.forEach(display => {
    display.innerHTML = '';
    display.style.display = 'none';
  });
}

function cleanupPetDataForRemovedItems(cartData) {
  const petsInfoCookie = getCookie('pets_info');
  if (!petsInfoCookie) {
    return;
  }

  let petsInfo;
  try {
    petsInfo = JSON.parse(petsInfoCookie);
  } catch (err) {
    return;
  }

  if (!petsInfo || petsInfo.length === 0) {
    return;
  }

  const currentProductHandles = cartData.items
    ? cartData.items.map(item => {
        return item.product_handle || item.handle || item.product_title?.toLowerCase().replace(/\s+/g, '-');
      })
    : [];

  const petsToKeep = petsInfo.filter(pet => {
    if (pet.redirectedTo) {
      const productStillInCart = currentProductHandles.some(handle => {
        return handle && handle.includes(pet.redirectedTo);
      });

      if (!productStillInCart) {
        return false;
      }
    }
    return true;
  });

  if (petsToKeep.length !== petsInfo.length) {
    if (petsToKeep.length > 0) {
      setCookie('pets_info', JSON.stringify(petsToKeep), 30);
    } else {
      setCookie('pets_info', '', -1);
    }

    setTimeout(() => {
      displayPetInfoFromCookie();
    }, 500);
  }
}

function checkAndCleanupPetInfoIfCartEmpty() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cart.item_count === 0) {
        cleanupPetInfoWhenCartEmpty();
      } else {
        cleanupPetDataForRemovedItems(cart);
      }
    })
    .catch(error => {
      // Silent error handling
    });
}

// ============================================================================
// MONITOR CART UPDATES (QTY/REMOVE)
// ============================================================================
function setupCartRemovalMonitoring() {
  const originalUpdateQuantity = window.CartItems?.prototype?.updateQuantity;

  if (originalUpdateQuantity) {
    window.CartItems.prototype.updateQuantity = function(line, quantity, event, name, variantId) {
      const result = originalUpdateQuantity.call(this, line, quantity, event, name, variantId);

      if (quantity === 0) {
        setTimeout(() => {
          checkAndCleanupPetInfoIfCartEmpty();
          displayPetInfoFromCookie();
        }, 1000);
      } else {
        setTimeout(() => {
          displayPetInfoFromCookie();
        }, 1000);
      }

      return result;
    };
  }

  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (
      url &&
      (url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/add'))
    ) {
      return originalFetch.call(this, url, options).then(response => {
        const clonedResponse = response.clone();

        if (response.ok) {
          clonedResponse.text().then(text => {
            try {
              const data = JSON.parse(text);

              if (data.item_count === 0) {
                cleanupPetInfoWhenCartEmpty();
              } else {
                cleanupPetDataForRemovedItems(data);
              }

              displayPetInfoFromCookie();
            } catch (err) {
              // Silent error handling
            }
          });
        }

        return response;
      });
    }

    return originalFetch.call(this, url, options);
  };
}

// ============================================================================
// GLOBAL EXPORTS
// ============================================================================
window.displayPetInfoFromCookie = displayPetInfoFromCookie;

// ============================================================================
// ON PAGE LOAD
// ============================================================================
document.addEventListener('DOMContentLoaded', function() {
  displayPetInfoFromCookie();
  setupCartRemovalMonitoring();
});
